// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"34ca2f31","301":"6290067e","650":"f4c4d241"}[chunkId] + ".chunk.js";
};